<div *ngIf="isVisible" class="vehicle-list-details-container" [ngClass]="styleClass" [@openClose]>

    <!-- place holder -->
    <tk-common-placeholder *ngIf="isLoading === true"></tk-common-placeholder>

    <!-- dane -->
    <div class="data-loaded" *ngIf="isLoading === false">

        <!-- jak zaladowano -->
        <ng-container *ngIf="vehicle">
            <tk-vehicle-details-header [vehicle]="vehicle" #header></tk-vehicle-details-header>
            <tk-vehicle-details-tabs [vehicle]="vehicle"></tk-vehicle-details-tabs>
        </ng-container>
    </div>
</div>
